export default __webpack_public_path__ + "static/media/firstwebsite.57f8991c.png";